global.BASE_URL = 'https://pc.easyteaching.cn'
global.BASE_VERSION = '3.20.4'
global.BASE_BUCKET = 'easyteaching'
global.BASE_BUCKET_TEMP = 'easyteaching-temp'



// WEBPACK FOOTER //
// ./src/global.js